import { PlayerEvent } from '@cbsinteractive/avia-js';
import { PlayerAdapterEvent } from 'library/ts/player/adapter/events/PlayerAdapterEvent';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class AviaEventTransformer extends AbstractTagClass {
    #aviaPlayerWrapper;
    #tagEventVO;
    #trackableEvents = {
        [PlayerEvent.ACTIVE_STATE_CHANGE]: PlayerAdapterEvent.ACTIVE_STATE_CHANGE,
        [PlayerEvent.AD_BREAK_COMPLETE]: PlayerAdapterEvent.AD_BREAK_COMPLETE,
        [PlayerEvent.AD_BREAK_DISCARDED]: PlayerAdapterEvent.AD_BREAK_DISCARDED,
        [PlayerEvent.AD_BREAK_METADATA]: PlayerAdapterEvent.AD_BREAK_METADATA,
        [PlayerEvent.AD_BREAK_START]: PlayerAdapterEvent.AD_BREAK_START,
        [PlayerEvent.AD_CLICK]: PlayerAdapterEvent.AD_CLICK,
        [PlayerEvent.AD_COMPLETE]: PlayerAdapterEvent.AD_COMPLETE,
        [PlayerEvent.AD_CUEPOINTS_AVAILABLE]: PlayerAdapterEvent.AD_CUEPOINTS_AVAILABLE,
        [PlayerEvent.AD_FIRST_QUARTILE]: PlayerAdapterEvent.AD_FIRST_QUARTILE,
        [PlayerEvent.AD_MIDPOINT]: PlayerAdapterEvent.AD_MIDPOINT,
        [PlayerEvent.AD_PAUSED]: PlayerAdapterEvent.AD_PAUSED,
        [PlayerEvent.AD_PLAYING]: PlayerAdapterEvent.AD_PLAYING,
        [PlayerEvent.AD_PROGRESS]: PlayerAdapterEvent.AD_PROGRESS,
        [PlayerEvent.AD_SEGMENT_END]: PlayerAdapterEvent.AD_SEGMENT_END,
        [PlayerEvent.AD_SEGMENT_REENTERED]: PlayerAdapterEvent.AD_SEGMENT_REENTERED,
        [PlayerEvent.AD_SEGMENT_START]: PlayerAdapterEvent.AD_SEGMENT_START,
        [PlayerEvent.AD_SKIPPABLE_STATE_CHANGE]: PlayerAdapterEvent.AD_SKIPPABLE_STATE_CHANGE,
        [PlayerEvent.AD_SKIPPED]: PlayerAdapterEvent.AD_SKIPPED,
        [PlayerEvent.AD_STALLED]: PlayerAdapterEvent.AD_STALLED,
        [PlayerEvent.AD_START]: PlayerAdapterEvent.AD_START,
        [PlayerEvent.AD_THIRD_QUARTILE]: PlayerAdapterEvent.AD_THIRD_QUARTILE,
        [PlayerEvent.AUDIO_TRACK_CHANGE]: PlayerAdapterEvent.AUDIO_TRACK_CHANGE,
        [PlayerEvent.AUDIO_TRACKS_CHANGE]: PlayerAdapterEvent.AUDIO_TRACKS_CHANGE,
        [PlayerEvent.AUTOPLAY_BLOCKED]: PlayerAdapterEvent.AUTOPLAY_BLOCKED,
        [PlayerEvent.CDN_CHANGE]: PlayerAdapterEvent.CDN_CHANGE,
        [PlayerEvent.CLOCK]: PlayerAdapterEvent.CLOCK,
        [PlayerEvent.CONTENT_COMPLETE]: PlayerAdapterEvent.CONTENT_COMPLETE,
        [PlayerEvent.CONTENT_DURATION_AVAILABLE]: PlayerAdapterEvent.CONTENT_DURATION_AVAILABLE,
        [PlayerEvent.CONTENT_IS_PLAYING_LIVE]: PlayerAdapterEvent.CONTENT_IS_PLAYING_LIVE,
        [PlayerEvent.CONTENT_PAUSED]: PlayerAdapterEvent.CONTENT_PAUSED,
        [PlayerEvent.CONTENT_PLAYING]: PlayerAdapterEvent.CONTENT_PLAYING,
        [PlayerEvent.CONTENT_PROGRESS]: PlayerAdapterEvent.CONTENT_PROGRESS,
        [PlayerEvent.CONTENT_SEGMENT_END]: PlayerAdapterEvent.CONTENT_SEGMENT_END,
        [PlayerEvent.CONTENT_SEGMENT_START]: PlayerAdapterEvent.CONTENT_SEGMENT_START,
        [PlayerEvent.CONTENT_START]: PlayerAdapterEvent.CONTENT_START,
        [PlayerEvent.DRM_KEY_SYSTEM_CREATED]: PlayerAdapterEvent.DRM_KEY_SYSTEM_CREATED,
        [PlayerEvent.ERROR]: PlayerAdapterEvent.ERROR,
        [PlayerEvent.FULLSCREEN_CHANGE]: PlayerAdapterEvent.FULLSCREEN_CHANGE,
        [PlayerEvent.LANGUAGE_CHANGE]: PlayerAdapterEvent.LANGUAGE_CHANGE,
        [PlayerEvent.LIVE_PRESENTATION_STOPPED]: PlayerAdapterEvent.LIVE_PRESENTATION_STOPPED,
        [PlayerEvent.LOG_EVENT]: PlayerAdapterEvent.LOG_EVENT,
        [PlayerEvent.METADATA_CUEPOINT]: PlayerAdapterEvent.METADATA_CUEPOINT,
        [PlayerEvent.METRIC]: PlayerAdapterEvent.METRIC,
        [PlayerEvent.MUTE_CHANGE]: PlayerAdapterEvent.MUTE_CHANGE,
        [PlayerEvent.PLAYBACK_RESUMED]: PlayerAdapterEvent.PLAYBACK_RESUMED,
        [PlayerEvent.PLAYBACK_STARTED]: PlayerAdapterEvent.PLAYBACK_STARTED,
        [PlayerEvent.PLAYBACK_STATE_CHANGE]: PlayerAdapterEvent.PLAYBACK_STATE_CHANGE,
        [PlayerEvent.PLAYBACK_SUSPENDED]: PlayerAdapterEvent.PLAYBACK_SUSPENDED,
        [PlayerEvent.PLUGIN_EVENT]: PlayerAdapterEvent.PLUGIN_EVENT,
        [PlayerEvent.PRESENTATION_SIZE_CHANGE]: PlayerAdapterEvent.PRESENTATION_SIZE_CHANGE,
        [PlayerEvent.QUALITIES_CHANGE]: PlayerAdapterEvent.QUALITIES_CHANGE,
        [PlayerEvent.QUALITY_CHANGE]: PlayerAdapterEvent.QUALITY_CHANGE,
        [PlayerEvent.READY]: PlayerAdapterEvent.READY,
        [PlayerEvent.RESOURCE_BUFFERING]: PlayerAdapterEvent.RESOURCE_BUFFERING,
        [PlayerEvent.RESOURCE_END]: PlayerAdapterEvent.RESOURCE_END,
        [PlayerEvent.RESOURCE_START]: PlayerAdapterEvent.RESOURCE_START,
        [PlayerEvent.SEEK_COMPLETE]: PlayerAdapterEvent.SEEK_COMPLETE,
        [PlayerEvent.SEEK_REDIRECT_COMPLETE]: PlayerAdapterEvent.SEEK_REDIRECT_COMPLETE,
        [PlayerEvent.SEEK_REDIRECT_START]: PlayerAdapterEvent.SEEK_REDIRECT_START,
        [PlayerEvent.SEEK_START]: PlayerAdapterEvent.SEEK_START,
        [PlayerEvent.STREAM_ID_AVAILABLE]: PlayerAdapterEvent.STREAM_ID_AVAILABLE,
        [PlayerEvent.STREAM_METADATA]: PlayerAdapterEvent.STREAM_METADATA,
        [PlayerEvent.STREAM_TYPE_CHANGE]: PlayerAdapterEvent.STREAM_TYPE_CHANGE,
        [PlayerEvent.TEXT_CUEPOINT]: PlayerAdapterEvent.TEXT_CUEPOINT,
        [PlayerEvent.TEXT_TRACK_AVAILABLE]: PlayerAdapterEvent.TEXT_TRACK_AVAILABLE,
        [PlayerEvent.TEXT_TRACK_CHANGE]: PlayerAdapterEvent.TEXT_TRACK_CHANGE,
        [PlayerEvent.TEXT_TRACK_ENABLED_CHANGE]: PlayerAdapterEvent.TEXT_TRACK_ENABLED_CHANGE,
        [PlayerEvent.TEXT_TRACKS_CHANGE]: PlayerAdapterEvent.TEXT_TRACKS_CHANGE,
        [PlayerEvent.THUMBNAIL_TRACK_AVAILABLE]: PlayerAdapterEvent.THUMBNAIL_TRACK_AVAILABLE,
        [PlayerEvent.VIDEO_ELEMENT_ADDED]: PlayerAdapterEvent.VIDEO_ELEMENT_ADDED,
        [PlayerEvent.VIDEO_ELEMENT_REMOVED]: PlayerAdapterEvent.VIDEO_ELEMENT_REMOVED,
        [PlayerEvent.VOLUME_CHANGE]: PlayerAdapterEvent.VOLUME_CHANGE,
        [PlayerEvent.WAITING_CHANGE]: PlayerAdapterEvent.WAITING_CHANGE,
        [PlayerEvent.SHOW_AD_UI]: PlayerAdapterEvent.SHOW_AD_UI,
        [PlayerEvent.HIDE_AD_UI]: PlayerAdapterEvent.HIDE_AD_UI
    };
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaEventTransformer'
        });
        this.#aviaPlayerWrapper = argument?.aviaPlayerWrapper;
    }
    get player() {
        return this.#aviaPlayerWrapper?.adaptedPlayerInstance;
    }
    #getInternalEvent = (event) => {
        this.#tagEventVO = this.getTagEventVO(TagEvent.ON_PLAYER_EVENT, this.tag, this.getTagEventDataVO(), this, this.name);
        this.#tagEventVO.data = {};
        const aviaPlayerEvent = event;
        const internalEvent = this.#trackableEvents[event?.type];
        if (!this.utils.Type.isEmpty(internalEvent)) {
            this.#tagEventVO.data.player = this.#aviaPlayerWrapper.API;
            this.#tagEventVO.data.adaptedPlayerInstance = this.player;
            this.#tagEventVO.data.playerNumber = this.tag.controller.playerManager.playerAdapter.playerNumber;
            this.#tagEventVO.data.resourceConfig = this.tag.controller.playerManager.currentResource;
            this.#tagEventVO.data.adaptedPlayerEvent = aviaPlayerEvent;
            if (this?.params?.SYSTEM?.embedType === EmbedType.DESKTOP) {
                this.#tagEventVO.data.playerAdapterEvent = this.utils.DeepMerge.deepmerge({}, aviaPlayerEvent);
            }
            else {
                this.#tagEventVO.data.playerAdapterEvent = aviaPlayerEvent;
            }
            this.#tagEventVO.data.playerAdapterEvent.target = this.tag.controller.playerManager.playerAdapter.player;
            this.#tagEventVO.data.playerAdapterEvent.type = internalEvent;
            this.#tagEventVO.data.playerEvent = this.#tagEventVO.data.playerAdapterEvent;
        }
        return this.#tagEventVO;
    };
    onPlayerEvent = (event) => {
        this.#tagEventVO = this.#getInternalEvent(event);
        if (event?.type === PlayerEvent.ERROR
            &&
                event?.detail?.fatal === true
            &&
                this.utils.Type.isFunction(this.#aviaPlayerWrapper?.API?.removePlayerEventListener)) {
            this.#aviaPlayerWrapper.API.removePlayerEventListener().then((data) => {
                this.tag.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_TAG_PLAYER_STOP_REQUEST, this?.tag, undefined, this, this?.name));
            });
        }
        if (!this.utils.Type.isEmpty(this.#tagEventVO?.data?.playerAdapterEvent?.type)) {
            switch (this.#tagEventVO?.data?.playerAdapterEvent?.type) {
                case PlayerAdapterEvent.CLOCK:
                case PlayerAdapterEvent.LOG_EVENT:
                    break;
                default:
                    switch (this.#tagEventVO?.data?.playerAdapterEvent?.type) {
                        case PlayerAdapterEvent.ACTIVE_STATE_CHANGE:
                        case PlayerAdapterEvent.AD_PROGRESS:
                        case PlayerAdapterEvent.CONTENT_PROGRESS:
                        case PlayerAdapterEvent.METRIC:
                            break;
                        default:
                            this?.logger?.log('onPlayerEvent', this.#tagEventVO.data.playerAdapterEvent.type, this.#tagEventVO);
                    }
                    this.tag.controller.playerManager.onPlayerAdapterEvent(this.#tagEventVO);
            }
        }
        else {
            this?.logger?.warn('onPlayerEvent', 'Match for avia event:', event?.type, 'was not found or not internalized => do not dispatch!');
        }
    };
}
